module.exports = __webpack_public_path__ + "static/media/19.5def8c03.jpg";